import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress
} from '@mui/material';

import { FunctionComponent, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

type BaseProps = {
  onClose: Function;
  title: string;
  open: boolean;
  className?: string;
  validation?: Function;
  confirmButtonText?: string | undefined;
  children?: ReactNode;
  isPending?: boolean;
};

type WithoutOnConfirm = BaseProps & {
  onConfirm?: never;
  customConfirm: ReactNode;
};

type WithOnConfirm = BaseProps & {
  onConfirm: Function;
  customConfirm?: never;
};

type Props = WithoutOnConfirm | WithOnConfirm;

export const ConfirmationDialog: FunctionComponent<Props> = ({
  onClose,
  onConfirm,
  title,
  open,
  children,
  className,
  validation,
  confirmButtonText,
  customConfirm,
  isPending
}) => {
  const { t } = useTranslation();
  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onConfirm && onConfirm();
  };

  return (
    <Dialog disableEscapeKeyDown maxWidth="md" open={open} className={className}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent style={{ overflow: 'unset' }}>{children}</DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary" disabled={isPending}>
          {t(translations.common.cancel())}
        </Button>
        {customConfirm ? (
          customConfirm
        ) : (
          <Button
            onClick={handleOk}
            color="primary"
            disabled={isPending || (validation ? !validation() : false)}
          >
            {isPending ? (
              <CircularProgress size={20} />
            ) : (
              confirmButtonText || t(translations.common.ok())
            )}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
